import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  selectCompanyAddress,
  selectPrefix,
  selectWidth,
  selectreportFromDate,
  selectreportToDate,
  setreportsFromDate,
  setreportsTodate,
} from "../../utility/Redux/profile";
import { FromToDate } from "../../utility/component/fromToDate";
import CustomerMasterHelp from "../../help/customermasterHelp";
import { GetSaleSummary } from "./func";
import { selectToken } from "../../utility/Redux/security";
import AccountMasterHelp from "../../help/listAccountMasterHelp";
import { SaleSummaryColumns } from "./columns";
import Footer from "./footer";
import { useReactToPrint } from "react-to-print";
import GeniusTableReports from "../../utility/component/geniusComponents/geniusTableData";
import ViewBillModal from "../../billing/viewBillModal";
import PrintWithFooter from "../../utility/component/datagrid/printReportWithFooter";
import GeniusTableForReports from "../../utility/component/printReport";

import { SaleSummaryPrintColumns } from "./printColumns";
import { SaleSummaryPrintTherminalColumns } from "./therminaColumns";
import IsLocalData from "../../utility/component/isLocalData";
import FromToDateMobile from "../../utility/component/fromToDateMobile";
import NewPrintReport from "../../utility/component/datagrid/newPrintReport";
import { FormatNumber2 } from "../../utility/functions/formatNumber";
import { CallAPIPromise } from "../../billing/common";
import VoucherPrint from "./paymodeSummaryPrint";
import Brandhelp from "../../help/brandHelp";
import { setSpinnerLoading } from "../../utility/Redux/modal";
import { Pagination } from "@mui/material";
import { DepartmentMasterHelp, SectionMasterHelp, SubSecMasterHelp } from "../../help";

const MarginReport = () => {
  const prefix = useSelector(selectPrefix);
  const [summaryList, setSummaryList] = useState([]);
  const [fullList, setFullList] = useState([]);
  const fromDate = useSelector(selectreportFromDate);
  const ToDate = useSelector(selectreportToDate);
  const width = useSelector(selectWidth);
  const [billHelpStatus, setBillhelpStatus] = useState(false);
  const [saleType, setSaleType] = useState("Retail");
  const [billNo, setBillNo] = useState("");
  const printRef = useRef(null);
  const [brandHelpStatus,setBrandHelpStatus]=useState(false)
  const [sectionHelpStatus,setSectionHelpStatus]=useState(false)
  const paymodePrintRef = useRef();
  const [filterItem, setFilterItem] = useState("");
  const therminalRef = useRef(null);
  const PrintColumns = SaleSummaryPrintColumns(width);
  const therminalColoums = SaleSummaryPrintTherminalColumns(width);
  const [brandName,setBrandnName]=useState("")
  const [sectionName,setSectionName]=useState("")
  const [departmentName,setDepartmentName]=useState("")
  const [departmentHelpStatus,setDepartmentHelpStatus]=useState("")
  const [subSection,setSubSection]=useState("")
  const [subSectionHelp,setSubSectionHelp]=useState("")

  const [getCustomerData, setCustomerData] = useState({
    table_prefix: prefix,
    FDATE: moment(fromDate).format("YYYY-MM-DD"),
    TDATE: moment(ToDate).format("YYYY-MM-DD"),
    NAME: "",
    MOBILE: "",
    CUSTOMER_NAME: "",
    CUSTOMER_MOBILE: "",
  });
  const [paymodeSummary, setPaymodeSummary] = useState([]);
  const [paymodeprintStatus, setPaymodePrintStatus] = useState(false);
  const [customerName, setCustomerName] = useState("");
  const [paymodeType, setPaymodeType] = useState("All");
  const [isTaxHide, setIsTaxHided] = useState(true);
  const columns = SaleSummaryColumns(width);
 const [brandList,setBrandList]=useState([])
 const [pageNumber,setPageNumber]=useState(1)
 const [totalPages,setTotalPages]=useState("")
 const [sortType, setSortType] = useState("none"); 
  const [customerHelpStatus, setCustomerHelpStatus] = useState(false);
  const [partyHelpStatus, setPartyHelpStatus] = useState(false);
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const sortedBrandList = React.useMemo(() => {
    if (!brandList || brandList.length === 0) return [];
  
    let data = [...brandList];
  
    if (sortType === "margin_desc") {
      data.sort((a, b) => Number(b.MARGIN) - Number(a.MARGIN));
    }
  
    if (sortType === "margin_asc") {
      data.sort((a, b) => Number(a.MARGIN) - Number(b.MARGIN));
    }
  
    return data;
  }, [brandList, sortType]);
  const okButton = (type = saleType,page) => {
    console.log(type);
    setSummaryList([]);
  dispatch(setSpinnerLoading("Loading"))
    CallAPIPromise("/api/master/itemMarginReport", {
      table_prefix: prefix,
      BRAND_NAME: brandName||"",
      page:page?page:pageNumber?pageNumber:1,
      SECTION_NAME:sectionName,
          SUB_SEC_NAME:subSection,
          DEP_NAME:departmentName
    }).then((res) => {
      console.log(res)
      if (res.status === 200) {
        setTotalPages(res.data.response.totalPages)
        setBrandList(res.data.response.data);
      }
    }).finally(()=>{
      dispatch(setSpinnerLoading(false))
    })
  };


  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    pageStyle: `
  @page {
    size: landscape;
  }
`,
  });



  useEffect(() => {
    const callback = (details, data) => {
      setCustomerData({
        ...details[0],
        table_prefix: prefix,
      });
      setSummaryList(data);
      setFullList(data);

    };
    const elseFunc = () => {
      console.log("nothing");
    };
    IsLocalData("margin_report", callback, elseFunc);
  }, []);


  return (
    <div className=" bg-white flex flex-col h-full  overflow-y-auto ">
      <div className=" flex flex-col h-full p-3 ">
        <div>
          {window.innerWidth <= 764 ? (
            <FromToDateMobile
              maxWidth={"500px"}

              hideDate={true}
              otherButton={
                <div className="flex border-l  pl-3">
                  <button onClick={()=>{
setBrandHelpStatus(true)
                  }}>
                  <i className="bi bi-search text-sm  mr-2 text-orange" />

                  </button>
                <div className="text-sm ">
                  Brand Name
                </div>
                </div>
              }
              submit={() => okButton(saleType)}
            />
          ) : (
            <>
              <FromToDate
              hideDate={true}
        
                hideReset={true}
                submit={() => okButton(saleType)}
                otherButton={
                  <div className={"flex"}>
  <div className="flex items-center justify-between rounded-lg px-3 py-2 bg-white  transition-all">
                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => setBrandHelpStatus(true)}
                      className="flex items-center justify-center w-8 h-8 rounded-full bg-orange-100 hover:bg-orange-200 transition"
                    >
                      <i className="bi bi-search text-orange text-base" />
                    </button>
                
                    <div className="text-sm font-medium text-gray-700">
                      Brand Name {brandName ? `- ${brandName}` : ""}
                    </div>
                  </div>
                
                  {brandName && (
                    <button
                      onClick={() => setBrandnName("")}
                      className="flex ml-2 items-center justify-center w-8 h-8 rounded-sm  bg-gray-100 hover:bg-gray-200 transition"
                      title="Clear brand"
                    >
                      <i className="bi bi-x text-red-500 text-lg" />
                    </button>
                  )}
                </div>


                <div className="flex items-center ml-3 border-l justify-between  px-3 py-2 bg-white  transition-all">
                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => setSectionHelpStatus(true)}
                      className="flex items-center justify-center w-8 h-8 rounded-full bg-orange-100 hover:bg-orange-200 transition"
                    >
                      <i className="bi bi-search text-orange text-base" />
                    </button>
                
                    <div className="text-sm font-medium text-gray-700">
                      Section Name {sectionName ? `- ${sectionName}` : ""}
                    </div>
                  </div>
                
                  {sectionName && (
                    <button
                      onClick={() => setSectionName("")}
                      className="flex ml-2 items-center justify-center w-8 h-8 rounded-sm  bg-gray-100 hover:bg-gray-200 transition"
                      title="Clear brand"
                    >
                      <i className="bi bi-x text-red-500 text-lg" />
                    </button>
                  )}
                </div>

                <div className="flex items-center ml-3 border-l justify-between  px-3 py-2 bg-white  transition-all">
                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => setDepartmentHelpStatus(true)}
                      className="flex items-center justify-center w-8 h-8 rounded-full bg-orange-100 hover:bg-orange-200 transition"
                    >
                      <i className="bi bi-search text-orange text-base" />
                    </button>
                
                    <div className="text-sm font-medium text-gray-700">
                      Department Name {departmentName ? `- ${departmentName}` : ""}
                    </div>
                  </div>
                
                  {departmentName && (
                    <button
                      onClick={() => setDepartmentName("")}
                      className="flex ml-2 items-center justify-center w-8 h-8 rounded-sm  bg-gray-100 hover:bg-gray-200 transition"
                      title="Clear brand"
                    >
                      <i className="bi bi-x text-red-500 text-lg" />
                    </button>
                  )}
                </div>

                <div className="flex items-center ml-3 border-l justify-between  px-3 py-2 bg-white  transition-all">
                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => setSubSectionHelp(true)}
                      className="flex items-center justify-center w-8 h-8 rounded-full bg-orange-100 hover:bg-orange-200 transition"
                    >
                      <i className="bi bi-search text-orange text-base" />
                    </button>
                
                    <div className="text-sm font-medium text-gray-700">
                      Sub Section  {subSection ? `- ${subSection}` : ""}
                    </div>
                  </div>
                
                  {subSection && (
                    <button
                      onClick={() => setSubSection("")}
                      className="flex ml-2 items-center justify-center w-8 h-8 rounded-sm  bg-gray-100 hover:bg-gray-200 transition"
                      title="Clear brand"
                    >
                      <i className="bi bi-x text-red-500 text-lg" />
                    </button>
                  )}
                </div>
                  </div>
               
                
                }
              />
    
            </>
          )}
        </div>

        <div className="flex mt-2 items-center gap-3 ml-4">
  <div className="text-sm font-medium text-gray-700">
    Sort By:
  </div>

  <select
    value={sortType}
    onChange={(e) => setSortType(e.target.value)}
    className="border border-gray-300 rounded-md px-2 py-1 text-sm outline-none"
  >
    <option value="none">Default</option>
    <option value="margin_desc">Margin (High → Low)</option>
    <option value="margin_asc">Margin (Low → High)</option>
  </select>
</div>
        {sortedBrandList[0] ? (
          <div
            style={{
              height: `calc(100% - ${width <= 764 ? 220 : 200}px)`,
              width: "100%",
              marginTop: 10,
            }}
            className=" mb-2  "
          >
            <GeniusTableReports
              onRowDoubleClick={(row) => {
                const data = row.values;
                setBillNo(data.INVNO);
                setBillhelpStatus(true);
              }}
              pagination={
                <div
                  style={{
                    width: columns.reduce(
                      (acc, row) => acc + Number(row.width),
                      0
                    ),
                  }}
                  className="flex justify-center mt-1"
                >
                  {" "}
                  <Pagination
                    onChange={(e, v) => {
                      okButton(saleType,v);
                      setPageNumber(v)
                    }}
                    sx={{
                      "& .MuiPaginationItem-root": {
                        color: "#000",
                        backgroundColor: "#f3f4f6", // light gray
                        borderRadius: "8px", // rounded rectangle
                        margin: "0 4px",
                        minWidth: "36px",
                        height: "36px",
                      },
                  
                      "& .MuiPaginationItem-root:hover": {
                        backgroundColor: "#e5e7eb",
                      },
                  
                      "& .Mui-selected": {
                        backgroundColor: "#000 !important",
                        color: "#fff !important",
                      },
                  
                      "& .Mui-selected:hover": {
                        backgroundColor: "#000",
                      },
                    }}
                    count={totalPages}
                    page={pageNumber}
                  />{" "}
                </div>
              }
              data={sortedBrandList}
              columns={columns}
            />

            <div className="w-full mt-3 ">
              <div
                style={{
                  display: "none",
                }}
              >
                <div ref={printRef}>
                  <NewPrintReport
                    title={"Sale Summary"}
                    data={summaryList}
                    details={[
                      {
                        name: "From Date",
                        value: moment(fromDate).format("DD/MM/YYYY"),
                      },
                      {
                        name: "To Date",
                        value: moment(ToDate).format("DD/MM/YYYY"),
                      },
                      {
                        name: "Party Name",
                        value: getCustomerData.NAME,
                      },
                    ]}
                    columns={PrintColumns}
                    footer={
                      <Footer
                        isFeilds={
                          <div className="flex justify-end text-sm mt-2">
                            <div>
                              <div className="flex ">
                                <div className="font-semibold w-[160px] text-right ">
                                  Total Grant Total :
                                </div>
                                <div className="ml-2 flex flex-1 justify-end ">
                                  {FormatNumber2(
                                    summaryList.reduce(
                                      (acc, row) => acc + Number(row.GTOTAL),
                                      0
                                    )
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                        columns={PrintColumns}
                        rows={summaryList}
                      />
                    }
                  />
                </div>
              </div>
            </div>
          
          </div>
        ) : (
          <div className="h-full flex justify-center items-center text-sm text-gray-400 border mt-3 rounded-sm">
            No Records Found
          </div>
        )}


      </div>
      <AccountMasterHelp
        onRowClick={(e) => {
          setCustomerData((c) => {
            return {
              ...c,
              NAME: e.row.NAME,
              MOBILE: "",
              CUSTOMER_NAME: "",
              CUSTOMER_MOBILE: "",
            };
          });
          setCustomerName("");

          setPartyHelpStatus(false);
        }}
        status={partyHelpStatus}
        onClose={() => {
          setPartyHelpStatus(false);
        }}
      />
      <CustomerMasterHelp
        onRowClick={(e) => {
          setCustomerData((c) => {
            return {
              ...c,
              CUSTOMER_NAME: "",
              CUSTOMER_MOBILE: e.row.CUSTOMER_MOBILE,
              NAME: "",
              MOBILE: "",
            };
          });
          setCustomerName(e.row.CUSTOMER_NAME);
          setCustomerHelpStatus(false);
        }}
        onClose={() => {
          setCustomerHelpStatus(false);
        }}
        status={customerHelpStatus}
      />
      <ViewBillModal
        bill_performa={saleType === "Retail" ? "bills" : "orders"}
        hideOrderSlip={true}
        setSummaryList={setSummaryList}
        status={billHelpStatus}
        billNo={billNo}
        onBack={() => setBillhelpStatus(false)}
      />
      <VoucherPrint
        paymodeSummary={paymodeSummary}
        status={paymodeprintStatus}
        fromDate={fromDate}
        ToDate={ToDate}
        onClose={() => {
          setPaymodePrintStatus(false);
        }}
      />
      <Brandhelp
      status={brandHelpStatus}
      onRowClick={(p)=>{
setBrandHelpStatus(false)
setBrandnName(p.row.BRAND_NAME)
setDepartmentName("")
setSubSection("")
setSectionName("")
      }}
      onClose={()=>{
setBrandHelpStatus(false)

      }}
      />
        
       
          <SectionMasterHelp
      status={sectionHelpStatus}
      onRowClick={(p)=>{
setSectionHelpStatus(false)
setSectionName(p.row.SECTION_NAME)
setBrandnName("")
setDepartmentName("")
setSubSection("")

      }}
      onClose={()=>{
        setSectionHelpStatus(false)

      }}
      />
        <SubSecMasterHelp
      status={subSectionHelp}
      onRowClick={(p)=>{
setSubSectionHelp(false)
setSubSection(p.row.SUB_SEC_NAME)
setBrandnName("")
setDepartmentName("")
      }}
      onClose={()=>{
        setSubSectionHelp(false)
      }}
      />
<DepartmentMasterHelp
      status={departmentHelpStatus}
      onRowClick={(p)=>{
setDepartmentHelpStatus(false)
setDepartmentName(p.row.DEP_NAME)
setBrandnName("")
setSubSection("")
setSectionName("")
      }}
      onClose={()=>{
        setDepartmentHelpStatus(false)

      }}
      />
    </div>
  );
};

export default MarginReport;

